export default {
    unauthorized: {
        text: 'Error de autorización. Por favor, inicie sesión de nuevo.',
        title: 'Uups...',
    },
    unknown: {
        text: 'Error desconocido. Por favor, vuelve a intentarlo o contacte con nosotros.',
        title: 'Uups...',
    },
    notfound: {
        text: 'No se ha encontrado el recurso.',
        title: 'Uups...',
    },
    conflict: {
        text: 'Recurso invalido.',
        title: 'Uups...',
    },
    auth: {
        text: 'El usuario o la contraseña son incorrectos.',
        title: 'Error',
    },
    404: {
        title: 'Página no encontrada',
    },
    select: {
        noOptions: 'No se han encontrado elementos.',
    },
}
